import OutlineTextInput from './OutlineTextInput';

export default OutlineTextInput;